import script from "./Step2.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2.vue?vue&type=script&setup=true&lang=js"

import "./Step2.vue?vue&type=style&index=0&id=715a7202&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715a7202"]])

export default __exports__